"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { Fields, System } from "Constants/objects";
import { columnType, getFieldFormat, getSSTableCols, isDateByTypeStr, isEmptyValue, setSSTableCols } from "D5Utils/functions";
import { Messages } from "Messages";
import Uuid from "uuid";

var Columns =
/*#__PURE__*/
function () {
  /**
   * @param {Configurator} settings
   */
  function Columns(_ref) {
    var settings = _ref.settings;

    _classCallCheck(this, Columns);

    this.settings = settings;
    this.settings.columnNames = this.settings.viewSource.map(function (item) {
      return item[Fields.Name];
    });
  }

  _createClass(Columns, [{
    key: "isFilterEnabledByAddFilter",
    value: function isFilterEnabledByAddFilter(objectFieldIdName, keyFilterField) {
      return Object.keys(this.settings.filtersData || {}).find(function (item) {
        return item === objectFieldIdName || item === keyFilterField;
      }) == null;
    }
  }, {
    key: "isRequiredField",
    value: function isRequiredField(field) {
      var isRequired = field[Fields.ObjectFieldID_IsRequired];
      var name = field.Name;
      var dataType = field[Fields.ObjectFieldID_FieldType];

      if (dataType === System.FIELD_TYPE.BOOL) {
        isRequired = false;
      }

      if (isRequired && !name.includes(System.SYSTEM_PREFIX) && name !== this.settings.keyField) this.settings.requiredFields.push(name);
      return isRequired && name !== this.settings.keyField ? [{
        type: 'required'
      }] : null;
    }
  }, {
    key: "prepareColumns",
    value: function prepareColumns() {
      var _this = this;

      var prepared = this.settings.viewSource.map(function (column) {
        var dataField = column[Fields.Name],
            dictObj = column[Fields.ObjectFieldID_LinkedObjectID_Name],
            keyFilterField = column[Fields.KeyFilterField],
            dictKeyFld = column[Fields.ObjectFieldID_KeyObjectFieldID_Name],
            dictDisplayFld = column[Fields.DisplayField],
            displayType = column[Fields.DisplayType],
            sortOrder = column[Fields.SortByDefault] === 1 ? 'asc' : column[Fields.SortByDefault] === -1 ? 'desc' : undefined,
            allowFiltering = _this.isFilterEnabledByAddFilter(column[Fields.ObjectFieldID_Name], keyFilterField),
            allowEditing = allowFiltering && !Boolean(column[Fields.IsReadOnly]),
            isRequired = _this.isRequiredField(column),
            dataType = Columns.getColumnType(column);

        var props = {
          userData: {
            dictionaryObj: dictObj,
            dictionaryKeyFld: dictKeyFld,
            dictionaryDisplayFld: dictDisplayFld,
            keyFilterField: keyFilterField,
            objectFieldIdName: column[Fields.ObjectFieldID_Name],
            groupID: column[Fields.GroupID],
            groupParentID: column[Fields.GroupID_ParentGroupID],
            groupTitle: column[Fields.GroupID_Title],
            allowFiltering: allowFiltering
          },
          dataField: dataField,
          dataType: dataType,
          allowFiltering: allowFiltering,
          allowEditing: allowEditing,
          caption: column[Fields.Title],
          visible: Boolean(column[Fields.IsVisible]),
          visibleIndex: column[Fields.Order],
          orderNum: column[Fields.Order],
          // showEditorAlways: true,
          validationRules: isRequired,
          sortOrder: sortOrder,
          showInColumnChooser: !Columns.isSystemField(column),
          filterOperations: [],
          headerFilter: {
            allowSearch: true
          }
        };

        if (!isDateByTypeStr(dataType) && dataType !== 'string') {
          props.cellTemplate = function (container, options) {
            _this.cellTemplate(container, options, displayType);
          };
        }

        if (dataType === 'number') {
          props.format = getFieldFormat(column, Columns.getColumnType, _this);
          props.minWidth = 70;
        }

        if (dataType === 'boolean') {
          props.minWidth = 70;
        }

        return props;
      });
      prepared.push({
        dataField: this.settings.systemKeyField,
        dataType: columnType(this.settings.keyFieldType),
        visible: false,
        allowEditing: false,
        allowFiltering: false,
        allowSorting: false,
        showInColumnChooser: false,
        userData: {
          groupID: null
        }
      });
      prepared.push({
        name: "".concat(System.SYSTEM_PREFIX, "buttons_panel"),
        fixedPosition: "right",
        visible: false,
        visibleIndex: -2,
        cssClass: 'd5_buttons_panel',
        allowEditing: false,
        allowFiltering: false,
        allowFixing: false,
        allowHiding: false,
        allowGrouping: false,
        allowReordering: false,
        allowResizing: false,
        showInColumnChooser: false,
        userData: {
          groupID: null
        },
        minWidth: 70,
        width: 70,
        fixed: true,
        cellTemplate: function cellTemplate(element, _ref2) {
          var component = _ref2.component,
              rowIndex = _ref2.rowIndex;
          var column = component.columnOption("".concat(System.SYSTEM_PREFIX, "buttons_panel"));
          if (column.d5AddRow && element.parent().hasClass('dx-row-inserted') || column.d5EditRowIndex === rowIndex) _this.drawCommandEditCellInEditMode(element, component);
        }
      });
      return prepared;
    }
  }, {
    key: "getCommandEditCellButton",
    value: function getCommandEditCellButton(_ref3) {
      var iconType = _ref3.iconType,
          _ref3$text = _ref3.text,
          text = _ref3$text === void 0 ? '' : _ref3$text,
          onClick = _ref3.onClick,
          _ref3$hint = _ref3.hint,
          hint = _ref3$hint === void 0 ? '' : _ref3$hint,
          id = _ref3.id;
      var positionSymbol = iconType.indexOf(':');
      var libraryName = iconType.slice(0, positionSymbol);
      var iconName = iconType.slice(positionSymbol + 1);
      var item = null;
      return $("<div id=\"".concat(id || Uuid(), "\"/>")).dxButton({
        template: function template(buttonData, contentElement) {
          switch (libraryName) {
            case 'material':
              item = $("<span class=\"icon\"><i class=\"material-icons\">".concat(iconName, "</i><span class=\"dx-button-text\">").concat(text, "</span></span>"));
              break;

            case 'material2':
              item = $("<span class=\"icon material2-icon\"><i class=\"material2-icons ".concat(iconName, "\"/><span class=\"dx-button-text\">").concat(text, "</span></span>"));
              break;

            case 'fontawesome':
              item = $("<span class=\"icon\"><i class=\"fontawesome-icons ".concat(iconName, "\"/><span class=\"dx-button-text\">").concat(text, "</span></span>"));
              break;
          }

          item.appendTo(contentElement);
          return contentElement;
        },
        width: '28px',
        height: '38px',
        hint: hint
      });
    }
  }, {
    key: "drawCommandEditCellInEditMode",
    value: function drawCommandEditCellInEditMode(container) {
      var _this2 = this;

      var $cancel = this.getCommandEditCellButton({
        iconType: 'material:clear',
        hint: Messages.Controls.Cancel
      });
      var $save = this.getCommandEditCellButton({
        iconType: 'material:done',
        hint: Messages.Controls.Save,
        id: 'apply-row-button'
      });
      $cancel.on('mousedown', function () {
        return setTimeout(function () {
          return _this2.settings.cancelRowChanges();
        }, 1000);
      });
      $save.on('mousedown', function () {
        return setTimeout(function () {
          return _this2.settings.saveRowChanges();
        }, 1000);
      });
      container.append($save, $cancel);
    }
    /**
     * @param {object} container, DOM element
     * @param {object} options
     * @param {number} displayType
     */

  }, {
    key: "cellTemplate",
    value: function cellTemplate(container, options, displayType) {
      switch (displayType) {
        //link field
        case 1:
          options.value ? $("<div class='row-link-block'>").append($("<a target='_blank' href=\"".concat(options.value, "\">").concat(options.value, "</a>"))).appendTo(container) : container;
          break;
        //picture field

        case 2:
          options.value ? $("<div class='row-img-block'>").append($("<img src=".concat(options.value, ">"))).appendTo(container) : container;
          break;
        //password field

        case 3:
          container.text(String(options.value || '').split('').map(function () {
            return '*';
          }).join(''));
          break;

        default:
          if (isDateByTypeStr(options.column.dataType)) {// container.text(options.value && Globalize.formatDate(options.value));
          } else if (options.column.dataType === 'number') {
            var format = options.column.format;
            format = format && format.split('.')[1];

            if (format && format.length) {
              container.text(options.value && Globalize.numberFormatter({
                minimumFractionDigits: format.length
              })(options.value));
            } else {
              container.text(options.value && Globalize.formatNumber(options.value));
            }
          } else if (options.column.dataType === 'boolean') {
            options.value && $('<div/>').dxCheckBox({
              value: Boolean(options.value),
              readOnly: true,
              hoverStateEnabled: false
            }).appendTo(container);
          } else {
            container.text(options.value);
          }

      }
    }
  }, {
    key: "build",
    value: function build() {
      var loadedCols = this.prepareColumns();
      var lsColumns = getSSTableCols(this.settings.getLSName()); // if (!lsColumns)
      //     return this.buildColumnGroups(loadedCols);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var lsCol = _step.value;
          var df = lsCol.dataField || lsCol.name;

          if (!df) {
            //это группа
            loadedCols.push({
              alignment: lsCol.alignment,
              allowCollapsing: lsCol.allowCollapsing,
              allowEditing: lsCol.allowEditing,
              allowExporting: lsCol.allowExporting,
              allowFiltering: lsCol.allowFiltering,
              allowFixing: lsCol.allowFixing,
              allowGrouping: lsCol.allowGrouping,
              allowHiding: lsCol.allowHiding,
              allowReordering: lsCol.allowReordering,
              allowResizing: lsCol.allowResizing,
              allowSorting: lsCol.allowSorting,
              autoExpandGroup: lsCol.autoExpandGroup,
              caption: lsCol.caption,
              groupID: lsCol.groupID,
              groupParentID: lsCol.groupParentID,
              headerId: lsCol.headerId,
              index: lsCol.index,
              isBand: lsCol.isBand,
              minWidth: lsCol.minWidth,
              showInColumnChooser: lsCol.showInColumnChooser,
              visible: lsCol.visible,
              visibleIndex: lsCol.visibleIndex,
              width: lsCol.width
            });
            return "continue";
          }

          var i = loadedCols.findIndex(function (col) {
            return col.dataField === df;
          });

          if (i === -1) {
            return "continue";
          }

          if (lsCol.hasOwnProperty('visible')) loadedCols[i].visible = lsCol.visible;
          if (lsCol.hasOwnProperty('visibleIndex')) loadedCols[i].visibleIndex = lsCol.visibleIndex;
          if (lsCol.hasOwnProperty('width')) loadedCols[i].width = lsCol.width;

          if (lsCol.hasOwnProperty('sortOrder')) {
            loadedCols[i].sortIndex = lsCol.sortIndex;
            loadedCols[i].sortOrder = lsCol.sortOrder;
          }

          if (lsCol.hasOwnProperty('fixed')) {
            loadedCols[i].fixed = lsCol.fixed;
            loadedCols[i].fixedPosition = lsCol.fixedPosition;
          }

          if (lsCol.hasOwnProperty('filterValue')) {
            var value = lsCol.filterValue;

            if (isDateByTypeStr(lsCol.dataType) && value) {
              if (Array.isArray(value)) {
                value = value.map(function (v) {
                  return v && new Date(v);
                });
              } else {
                value = new Date(value);
              }
            }

            if (lsCol.dataType === 'boolean' && value != null) value = Boolean(value);
            if (!isEmptyValue(value)) loadedCols[i].filterValue = value;
          }

          if (lsCol.hasOwnProperty('realOperation')) {
            if (!loadedCols[i].userData) {
              loadedCols[i].userData = {};
            }

            loadedCols[i].userData.realOperation = lsCol.realOperation;
          }
        };

        for (var _iterator = lsColumns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.buildColumnGroups(loadedCols);
    }
    /**
     * @param {array} columns - Массив содержит колонки и групп. Группы не содержат свойство userData
     * @return {*}
     */

  }, {
    key: "buildColumnGroups",
    value: function buildColumnGroups(columns) {
      var _this3 = this;

      if (!this.settings.groups.length) return columns;
      var loadedGroups = this.settings.groups.length ? _toConsumableArray(this.settings.groups) : [];
      var out = [];

      var findLSGroup = function findLSGroup(groupID) {
        return columns.find(function (col) {
          return col.groupID === groupID;
        });
      }; //группируем колонки по groupID


      var groups = _.groupBy(columns.filter(function (g) {
        return g.hasOwnProperty('userData');
      }), function (item) {
        return item.userData.groupID;
      });

      if (groups.hasOwnProperty('null')) {
        out = _toConsumableArray(groups['null']); //записываем все колонки у которых нет групп

        delete groups['null'];
      } //создаем массив групп из исходных данных и записываем сгруппированные клонки колонки


      loadedGroups = _.map(loadedGroups, function (group) {
        var gr = findLSGroup(group.ID);

        if (gr) {
          var outGroup = _objectSpread({}, gr, {
            columns: !groups[group.ID] ? [] : _toConsumableArray(groups[group.ID])
          });

          if (!outGroup.hasOwnProperty('visible')) outGroup.visible = Boolean(group.IsVisible);
          return outGroup;
        }

        return {
          groupID: group.ID,
          visibleIndex: group.Order,
          visible: Boolean(group.IsVisible),
          groupParentID: group.ParentGroupID,
          caption: group.Title,
          alignment: 'center',
          columns: !groups[group.ID] ? [] : _toConsumableArray(groups[group.ID])
        };
      }); //группируем массив групп колонок

      loadedGroups = _.groupBy(loadedGroups, function (item) {
        return item.groupParentID;
      });

      if (loadedGroups.hasOwnProperty('null')) {
        out = [].concat(_toConsumableArray(out), _toConsumableArray(loadedGroups['null'])); //записываем все группы у которых нет родителя

        delete loadedGroups['null'];
      } //создаем группы для групп


      var t = _.map(loadedGroups, function (item, key) {
        var loaded = _this3.settings.groups.find(function (l) {
          return l.ID == key;
        });

        var gr = findLSGroup(loaded.ID);
        if (gr) return _objectSpread({}, gr, {
          columns: _toConsumableArray(item)
        });
        return {
          groupID: loaded.ID,
          visibleIndex: loaded.Order,
          groupParentID: loaded.ParentGroupID,
          caption: loaded.Title,
          alignment: 'center',
          columns: _toConsumableArray(item)
        };
      }); //записываем в рещультирующий массив


      t.forEach(function (item) {
        var groupIdx = out.findIndex(function (i) {
          return i.groupID === item.groupID;
        });

        if (~groupIdx) {
          out[groupIdx].columns = [].concat(_toConsumableArray(out[groupIdx].columns), _toConsumableArray(item.columns));
        }
      });
      out = _.sortBy(out, 'visibleIndex'); //сортируем по visibleIndex

      return out;
    }
  }], [{
    key: "getColumnType",
    value: function getColumnType(column) {
      var type = column[Fields.ObjectFieldID_FieldType];
      var withTime = column[Fields.ObjectFieldID_IsTimeAllowed];
      return columnType(type, withTime);
    }
  }, {
    key: "isSystemField",
    value: function isSystemField(field) {
      return field[Fields.Name].indexOf(System.SYSTEM_PREFIX) === 0;
    }
  }, {
    key: "isLookup",
    value: function isLookup(field) {
      return field[Fields.ObjectFieldID_LinkedObjectID] != null;
    }
  }, {
    key: "saveColumnsToLS",
    value: function saveColumnsToLS(state, viewSource, grid, lsName) {
      var cols = {};
      if (!state.columns || !state.columns.length) return;
      var columns = [];

      var _loop2 = function _loop2(i) {
        var column = grid.columnOption(i);
        var dataFieldName = column.dataField || column.name;

        if (!dataFieldName) {
          //скорее всего это группирующая колонка
          columns.push({
            alignment: column.alignment,
            allowCollapsing: column.allowCollapsing,
            allowEditing: column.allowEditing,
            allowExporting: column.allowExporting,
            allowFiltering: column.allowFiltering,
            allowFixing: column.allowFixing,
            allowGrouping: column.allowGrouping,
            allowHiding: column.allowHiding,
            allowReordering: column.allowReordering,
            allowResizing: column.allowResizing,
            allowSorting: column.allowSorting,
            autoExpandGroup: column.autoExpandGroup,
            caption: column.caption,
            groupID: column.groupID,
            groupParentID: column.groupParentID,
            headerId: column.headerId,
            index: column.index,
            isBand: column.isBand,
            minWidth: column.minWidth,
            showInColumnChooser: column.showInColumnChooser,
            visible: column.visible,
            visibleIndex: column.visibleIndex,
            width: column.width
          });
          return "continue";
        }

        if (dataFieldName.indexOf(System.SYSTEM_PREFIX) === 0) return "continue";

        var field = _.find(viewSource, function (f) {
          return f.Name === dataFieldName;
        });

        if (field) {
          cols[dataFieldName] = {
            index: i,
            ObjectFieldID: field[Fields.ObjectFieldID],
            Name: field[Fields.Name],
            IsLookup: Columns.isLookup(field),
            DisplayField: field[Fields.DisplayField],
            realOperation: column.userData.realOperation
          };
        }
      };

      for (var i = 0; i < grid.columnCount(); ++i) {
        var _ret2 = _loop2(i);

        if (_ret2 === "continue") continue;
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = state.columns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var col = _step2.value;

          if (cols[col.dataField] && col.dataField.indexOf(System.SYSTEM_PREFIX)) {
            columns.push(_objectSpread({}, col, {
              index: cols[col.dataField].index,
              ObjectFieldID: cols[col.dataField].ObjectFieldID,
              Name: cols[col.dataField].Name,
              realOperation: cols[col.dataField].realOperation,
              IsLookup: cols[col.dataField].IsLookup,
              DisplayField: cols[col.dataField].DisplayField,
              sortIndex: col.hasOwnProperty('sortIndex') ? col.sortIndex : '',
              sortOrder: col.hasOwnProperty('sortOrder') ? col.sortOrder : ''
            }));
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      setSSTableCols(lsName, columns);
    }
  }]);

  return Columns;
}();

export { Columns as default };